const DAY = 86400;
const PRESET_DAYS = { '1d': 1, '7d': 7, '30d': 30 };

export const EXPIRY_PRESETS = ['never', '1d', '7d', '30d', 'custom'];

// unit = quota per currency unit (e.g. 500000 per $1), or 1 for raw quota.
export function quotaToAmount(quota, unit) {
  const q = Number(quota) || 0;
  return unit > 1 ? (q / unit).toFixed(2) : String(Math.round(q));
}

export function amountToQuota(amount, unit) {
  if (amount === '' || amount === null || amount === undefined) return null;
  const n = Number(amount);
  if (!Number.isFinite(n) || n < 0) return null;
  return Math.round(n * (unit > 1 ? unit : 1));
}

export function expiryForPreset(preset, nowSec) {
  if (preset === 'never') return -1;
  if (PRESET_DAYS[preset]) return nowSec + PRESET_DAYS[preset] * DAY;
  return null;
}

export function presetForExpiry(expiredTime) {
  return expiredTime === -1 ? 'never' : 'custom';
}

const pad = (n) => String(n).padStart(2, '0');

export function toLocalInputValue(sec) {
  const d = new Date(sec * 1000);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function fromLocalInputValue(value) {
  if (!value) return null;
  const ms = new Date(value).getTime();
  return Number.isNaN(ms) ? null : Math.floor(ms / 1000);
}

export function maskKey(key) {
  if (!key) return '';
  if (key.length <= 8) return 'sk-' + key;
  return `sk-${key.slice(0, 4)}…${key.slice(-4)}`;
}

export const PAYLOAD_LOG_DAYS = [7, 30, 90, 365, -1];

// New tokens log content by default; the owner can turn it off or pick another retention.
export const DEFAULT_PAYLOAD_LOG_DAYS = 30;

export function payloadGoesToArchive(days) {
  return days === 90 || days === 365 || days === -1;
}
